import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, PackageSearch, User, LayoutDashboard, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";

const navCls = ({ isActive }) =>
  `text-sm font-semibold transition-colors hover:text-sky-600 ${isActive ? "text-sky-600" : "text-slate-600"}`;

export function Header() {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-md" data-testid="site-header">
      <div className="cmyk-bar" />
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          <NavLink to="/" end className={navCls} data-testid="nav-products">Produtos</NavLink>
          <NavLink to="/rastrear" className={navCls} data-testid="nav-track">Rastrear pedido</NavLink>
        </nav>
        <div className="flex items-center gap-1 sm:gap-2">
          <Link to="/rastrear" className="md:hidden p-2 text-slate-600" data-testid="nav-track-mobile" aria-label="Rastrear pedido">
            <PackageSearch className="h-5 w-5" />
          </Link>
          {user?.role === "admin" && (
            <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin">
              <LayoutDashboard className="h-4 w-4" /> <span className="hidden sm:inline">Painel</span>
            </Button>
          )}
          {user ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/conta")} data-testid="nav-account">
                <User className="h-4 w-4" /> <span className="hidden sm:inline">{{ reseller: "Área do revendedor", store: "Área da loja", vip: "Área VIP" }[user.role] || "Minha conta"}</span>
              </Button>
              <Button variant="ghost" size="icon" onClick={logout} data-testid="nav-logout" aria-label="Sair">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button variant="ghost" size="sm" onClick={() => navigate("/entrar")} data-testid="nav-login">
              <User className="h-4 w-4" /> <span className="hidden sm:inline">Entrar</span>
            </Button>
          )}
          <Button onClick={() => navigate("/carrinho")} className="relative rounded-full bg-slate-900 hover:bg-sky-600" size="sm" data-testid="nav-cart">
            <ShoppingBag className="h-4 w-4" />
            <span className="hidden sm:inline">Carrinho</span>
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -right-1.5 -top-1.5 grid h-5 min-w-5 place-items-center rounded-full bg-[#E5007D] px-1 text-[11px] font-bold text-white">
                {count}
              </span>
            )}
          </Button>
        </div>
      </div>
    </header>
  );
}
